module.exports = __webpack_public_path__ + "img/timeline_final_lazy.7b44ec3c.jpg";